// Text Field inputs
//
// Spec: http://www.google.com/design/spec/components/text-fields.html
//
// Single-line text fields:
//
// Without floating label:
//
//      | 16 |---
//   48 |    |Input Text (16sp)
//      | 16 |---
//
// With floating label:
//
//      | 16 |---
//      |    |Label Text (12sp)
//   72 |  8 |---
//      |    |Input Text (16sp)
//      | 16 |---

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

// Color of floating label and underline when focused
var focusColor = _style.Colors.blue.P500;

// Color of label when unfocused
var labelColor = _style.Colors.grey.P500;
var transitionDuration = '0.2s';
var textMargin = '0.5em 0 0.25em';
var TextFieldStyles = _reactStyle2['default'].create({
  normalTextFieldStyle: {
    background: 'transparent',
    fontFamily: _style.Typography.fontFamily,
    fontSize: 16,
    border: 'none',
    outline: 'none',
    left: 0,
    width: '100%',
    padding: 0,
    margin: textMargin
  },

  underlineContainerStyle: {
    position: 'relative',
    left: 0,
    right: 0,
    height: 0,
    overflow: 'visible'
  },

  underlineStyle: {
    backgroundColor: labelColor,
    height: 1
  },

  // style used for the underline when the input
  // has focus
  focusedUnderlineStyle: {
    backgroundColor: focusColor,
    height: 2,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    opacity: '0',
    transition: 'left ' + transitionDuration + ' ease-out, ' + ('right ' + transitionDuration + ' ease-out')
  },

  errorUnderlineStyle: {
    backgroundColor: _style.Colors.red.P400
  },

  fullWidthTextFieldStyle: {
    width: '100%'
  },

  placeHolderStyling: {
    color: labelColor,
    fontSize: 16,
    left: 1,
    position: 'absolute',
    opacity: '1',
    transition: 'top .18s linear, font-size .18s linear, opacity .10s linear',
    pointerEvents: 'none',
    margin: textMargin
  },

  floatingLabelPlaceHolderStyling: {
    top: 27
  },

  containerStyling: {
    position: 'relative',
    width: 300,
    paddingBottom: 8
  },

  placeHolderTopStyling: {
    fontSize: 12,
    top: 4
  },

  scrollBlocksStyle: {
    backgroundColor: labelColor,
    bottom: 6,
    height: 3,
    opacity: '0',
    position: 'absolute',
    transition: 'opacity .28s linear',
    width: 3
    // ':before': {
    //   backgroundColor: labelColor,
    //   bottom: 0,
    //   content: "''",
    //   position: 'absolute',
    //   height: 3,
    //   width: 3,
    //   right: 6
    // },
    // ':after': {
    //   backgroundColor: labelColor,
    //   bottom: 0,
    //   content: "''",
    //   position: 'absolute',
    //   height: 3,
    //   width: 3,
    //   right: -6
    // }
  },

  focusStyle: {
    backgroundColor: focusColor
    // ':before': {
    //   backgroundColor: focusColor
    // },
    // ':after': {
    //   backgroundColor: focusColor
    // }
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      // indicates whether the input field has focus
      focus: false,
      // a flag set when the user initiates focusing the
      // text field and then cleared a moment later
      focusing: true
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'onMouseDown',
    value: function onMouseDown(e) {
      if (this.state.focus) {
        return;
      }
      this.setState({ focusX: e.clientX });
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(e) {
      if (this.state.focus) {
        return;
      }
      var touch = e.touches.item(0);
      this.setState({ focusX: touch.clientX });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var onChange = this.props.onChange;

      if (onChange) {
        onChange(e);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var onBlur = this.props.onBlur;

      this.setState({
        focus: false,
        focusX: null
      });
      if (onBlur) {
        onBlur(e);
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      var _this = this;

      var onFocus = this.props.onFocus;
      var focusX = this.state.focusX;

      this.setState({
        focus: true
      });

      // if the user focused via touch or mouse,
      // animate the focused underline, spilling from the horizontal
      // position of the mouse or touch
      if (focusX) {
        (function () {
          var underlineRect = _react2['default'].findDOMNode(_this.refs['underlineContainer']).getBoundingClientRect();
          var focusedUnderline = _react2['default'].findDOMNode(_this.refs['focusedUnderline']);

          _this.setState({ focusing: true });

          focusedUnderline.style.transition = 'none';

          focusedUnderline.style.left = '' + (_this.state.focusX - underlineRect.left) + 'px';
          focusedUnderline.style.right = '' + (underlineRect.right - _this.state.focusX) + 'px';

          setTimeout(function () {
            focusedUnderline.style.transition = '';
            focusedUnderline.style.left = '0px';
            focusedUnderline.style.right = '0px';

            _this.setState({ focusing: false });
          }, 1);
        })();
      }

      if (onFocus) {
        onFocus(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var defaultValue = _props.defaultValue;
      var error = _props.error;
      var floatingLabel = _props.floatingLabel;
      var placeHolder = _props.placeHolder;
      var styles = _props.styles;
      var type = _props.type;
      var value = _props.value;
      var focus = this.state.focus;

      var textField = this.refs.textField;

      var scrollLeft = 0;
      var scrollWidth = -1;
      var width = -1;

      var containerStyling = TextFieldStyles.containerStyling;
      var errorUnderlineStyle = TextFieldStyles.errorUnderlineStyle;
      var floatingLabelPlaceHolderStyling = TextFieldStyles.floatingLabelPlaceHolderStyling;
      var focusedUnderlineStyling = TextFieldStyles.focusedUnderlineStyling;
      var focusStyle = TextFieldStyles.focusStyle;
      var placeHolderStyling = TextFieldStyles.placeHolderStyling;
      var placeHolderTopStyling = TextFieldStyles.placeHolderTopStyling;
      var normalTextFieldStyle = TextFieldStyles.normalTextFieldStyle;
      var scrollBlocksStyle = TextFieldStyles.scrollBlocksStyle;
      var underlineContainerStyle = TextFieldStyles.underlineContainerStyle;
      var underlineStyle = TextFieldStyles.underlineStyle;

      var placeHolderStyles = [placeHolderStyling];

      if (floatingLabel) {
        placeHolderStyles.push(floatingLabelPlaceHolderStyling);
      }

      if (focus || value > 0) {
        if (floatingLabel) {

          placeHolderStyles.push(placeHolderTopStyling);

          if (focus) {
            placeHolderStyles.push({ color: focusColor });
          }
        } else {
          placeHolderStyles.push({ opacity: '0' });
        }
      }

      if (textField) {
        var textfieldDOMNode = _react2['default'].findDOMNode(textField);
        scrollWidth = textfieldDOMNode.scrollWidth;
        scrollLeft = textfieldDOMNode.scrollLeft;
        width = textfieldDOMNode.offsetWidth;
      }

      var containerStyles = [containerStyling];

      if (floatingLabel) {
        containerStyles.push({ height: '66px' });
      }
      containerStyles.push(styles.containerStyling);

      var textFieldStyling = [normalTextFieldStyle];
      if (floatingLabel) {
        textFieldStyling.push({ paddingTop: 25 });
      }

      var focusedUnderlineStyles = [focusedUnderlineStyling];
      if (focus) {
        focusedUnderlineStyles.push({ opacity: 1 });
      }

      if (error) {
        focusedUnderlineStyles.push(errorUnderlineStyle);
      }

      var focusStylesLeft = [scrollLeft ? { opacity: '1' } : null, focus ? focusStyle : null, scrollBlocksStyle, { left: '6px' }];

      var focusStylesRight = [scrollWidth > scrollLeft + width ? { opacity: '1' } : null, focus ? focusStyle : null, scrollBlocksStyle, { right: '6px' }];

      return _react2['default'].createElement(
        'div',
        { styles: containerStyles },
        _react2['default'].createElement(
          'div',
          { styles: placeHolderStyles },
          placeHolder
        ),
        _react2['default'].createElement('input', {
          defaultValue: defaultValue,
          onBlur: this.onBlur.bind(this),
          onChange: this.onChange.bind(this),
          onClick: this.onChange.bind(this),
          onFocus: this.onFocus.bind(this),
          onKeyUp: this.onChange.bind(this),
          onMouseDown: this.onMouseDown.bind(this),
          onTouchStart: this.onTouchStart.bind(this),
          onWheel: this.onChange.bind(this),
          ref: 'textField',
          styles: textFieldStyling,
          type: type || 'text',
          value: value }),
        _react2['default'].createElement(
          'div',
          {
            ref: 'underlineContainer',
            styles: underlineContainerStyle },
          _react2['default'].createElement('div', {
            ref: 'underline',
            styles: underlineStyle }),
          _react2['default'].createElement('div', {
            ref: 'focusedUnderline',
            styles: focusedUnderlineStyles })
        ),
        _react2['default'].createElement('div', { styles: focusStylesLeft }),
        _react2['default'].createElement('div', { styles: focusStylesRight })
      );
    }
  }], [{
    key: 'displayName',
    value: 'TextField',
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      styles: {}
    },
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      defaultValue: _react.PropTypes.string,
      error: _react.PropTypes.string,
      floatingLabel: _react.PropTypes.bool,
      onBlur: _react.PropTypes.func,
      onFocus: _react.PropTypes.func,
      onChange: _react.PropTypes.func,
      placeHolder: _react.PropTypes.string,
      styles: _react.PropTypes.object,
      type: _react.PropTypes.string,
      value: _react.PropTypes.number
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/TextField.js
 ** module id = 218
 ** module chunks = 0
 **/